import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import ReactGA from 'react-ga'

import { urlChanged } from '../../mixins/urls'
import { currentSite } from '../../mixins/siteDetection'

class Tracking extends Component {
  constructor(props) {
    super(props)

    this.state = {
      renderable: false,
      random: Math.floor(Math.random() * 1000000)
    }
  }

  componentDidMount() {
    const site = currentSite()

    ReactGA.initialize(site.gaId, {
      debug: process.env.NODE_ENV === 'development',
      testMode: process.env.NODE_ENV === 'development',
      gaOptions: {
        anonymizeIp: true
      }
    })

    this.trackView()
  }

  componentDidUpdate(prevProps) {
    if (urlChanged(prevProps, this.props, true)) {
      this.trackView()
    }
  }

  trackView() {
    this.setState(
      {
        random: Math.floor(Math.random() * 1000000),
        renderable: true
      },
      () => {
        ReactGA.pageview(
          this.props.location.pathname + this.props.location.search
        )
      }
    )
  }

  trackEvent() {}

  render() {
    const { renderable, random } = this.state;
    const site = currentSite();

    return (
      <>
        {renderable && <img key={"tpx" + random} src={`https://t.simply-hentai.com/t.png?r=${random}&index=${site.siteKey}`} id={"tpx"} style={{ position:"absolute", left: "-9999px" }} alt={""} />}
      </>
    );
  }
}

export default withRouter(Tracking)
